import { LabelEnum } from 'app/shared/enums';
import { isPeselValid } from 'app/services/pesel.service';

const pesel = (value: number | undefined | null) =>
  value && isPeselValid(value.toString()) ? undefined : LabelEnum.InvalidPesel;

export default pesel;
